module.exports = __webpack_public_path__ + "img/mask.fe4f8a6c.png";